<template>
  <mdb-icon
    v-if="recommended"
    color="success"
    class="fa-3x"
    icon="check"
    title="All rates in this pack have same agent"
  />
</template>

<script>
import { mdbIcon } from 'mdbvue'

export default {
  name: 'CalcRatesTableCellRecommended',
  props: {
    row: {
      type: Array,
      required: true
    }
  },
  computed: {
    recommended () {
      if (this.row.length <= 1) return false
      const arr = this.row.map(r => r.rateData.rate.agent.name)
      return arr.every(a => a === arr[0])
    }
  },
  components: {
    mdbIcon
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcRatesTableCellRecommended.vue